// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__mwnFX","hero_details":"Hero_hero_details__FBOGs","search":"Hero_search__XfMax","images":"Hero_images__avL+H","top":"Hero_top__4xpX3"};